/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const Binoculars: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M7 9H9V4H7V9ZM5.5 1H3.5C3.22375 1 3 1.22375 3 1.5V3H6V1.5C6 1.22375 5.77625 1 5.5 1ZM14.0028 4.99969C13.9878 4.44906 13.5559 4 13.005 4H10V9H11V14C11 14.5522 11.4478 15 12 15H15C15.5522 15 16 14.5522 16 14V12.625C15.8919 8.56938 14.0813 7.9325 14.0028 4.99969ZM1.99719 4.99969C1.91875 7.9325 0.108125 8.56938 0 12.625V14C0 14.5522 0.447812 15 1 15H4C4.55219 15 5 14.5522 5 14V9H6V4H2.995C2.44406 4 2.01219 4.44906 1.99719 4.99969ZM13 1.5C13 1.22375 12.7762 1 12.5 1H10.5C10.2238 1 10 1.22375 10 1.5V3H13V1.5Z'
			/>
		</Svg>
	);
};

export { Binoculars };
